import { defineStore } from 'pinia'
import { ElMessage } from 'element-plus'
import { persistConfig } from '../index'
import router from '@/router'
import {
  smsLoginApi,
  accountLogin
} from '@/api/modules/auth';
import {
  getUserInfo,
  updateUserInfoApi,
} from '@/api/modules/user';

// 创建auth store
export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: null,
    userInfo: null,
    isLoggedIn: false,
    loading: false,
    lastVisitedPath: null
  }),

  getters: {
    // 获取当前登录用户信息
    currentUser: (state) => state.userInfo,
  },

  actions: {
    // 设置token
    setToken(token) {
      this.token = token
      this.isLoggedIn = !!token
    },

    // 设置用户信息
    setUserInfo(userInfo) {
      this.userInfo = userInfo
    },

    // 登录
    async login(type, params) {
      try {
        this.loading = true;
        const api = type === 'account' ? accountLogin : smsLoginApi;
        const result = await api(params);
        
        // 如果登录成功，更新Pinia store
        if (result.code === 200 && result.data) {
          this.setToken(result.data.token);
          this.setUserInfo({
            ...result.data,
            id: result.data.userId || '',
          });
          await this.refreshUserInfo();
        }
        return result;
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },

    // 登出
    logout() {
      // 保存当前访问路径，排除登录页面
      const currentPath = window.location.hash.replace('#', '')
      if (!['/login'].includes(currentPath)) {
        this.lastVisitedPath = currentPath
      }
      
      this.setToken(null)
      this.setUserInfo(null)
      ElMessage.success('已成功登出')
      // 跳转到登录页面
      router.push('/login')
    },

    // 刷新用户信息
    async refreshUserInfo() {
      try {
        this.loading = true
        const userInfoResult = await getUserInfo(this.userInfo?.id);
        if (userInfoResult.code === 200 && userInfoResult.data) {
          this.setUserInfo({
            ...userInfoResult.data,
            id: userInfoResult.data.tableId || '',
          });
        }
        return userInfoResult
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },
    
    //更新用户信息
    async updateUserInfo(data) {
      try {
        this.loading = true
        const userInfoResult = await updateUserInfoApi({
          ...data,
          tableId: this.userInfo?.id,
        });
        if (userInfoResult.code === 200) {
          this.setUserInfo({
            ...(this.userInfo || {}),
            ...data,
          });
        }
        return userInfoResult
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },

    // 清除所有认证数据
    clearAuthData() {
      this.setToken(null)
      this.setUserInfo(null)
    }
  },

  // 配置持久化
  persist: persistConfig.createPersistConfig('auth', {
    // 额外的自定义配置
    afterRestore: (context) => {
      // 确保isLoggedIn状态正确反映token是否存在
      if (context.store.token) {
        context.store.isLoggedIn = true
      }
    }
  })
})